import { Grid, TextButton } from '@tfo/common'
import { inject } from 'mobx-react'
import * as React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { useHistory } from 'react-router-dom'
import IndividualHeader from '../../common/individual-header/IndividualHeader'
import { DeclinedViewModel } from '../../ViewModels'

import './Declined.scss'

type DeclinedProps  = DeclinedViewModel 

const { GridWrapper } = Grid

const Declined: React.FunctionComponent<DeclinedProps &
	WrappedComponentProps> = props => {
	const {declined, companyName, orderId} = props
	const history = useHistory()
	return (
		<GridWrapper className={'IndividualView Declined'}>
			<IndividualHeader
				companyName={companyName}
				headingId="declined.heading"
				preambleId="declined.body"
				preambleData={{
					date: props.intl.formatDate(declined),
					time: props.intl.formatTime(declined),
					companyName: companyName,
				}}
			/>

			<div className={'IndividualButtons'}>
				<TextButton
					className="Declined__TextButton Declined__TextButton--left"
					onClick={() =>
						history.push(`/approval/${orderId}`)
					}>
					{props.intl.formatMessage({ id: 'declined.btn.change' })}
				</TextButton>
			</div>
		</GridWrapper>
	)
}

export default inject('rootStore')(injectIntl(Declined))
